import { render, staticRenderFns } from "./ComponentListItem.vue?vue&type=template&id=5def646f&"
import script from "./ComponentListItem.vue?vue&type=script&lang=js&"
export * from "./ComponentListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports